module.exports = __webpack_public_path__ + "static/img/22.1.1.1f524744.png";